import {useMemo, useState} from "react";
import {useGoodsDetailContext} from "../../../../../../reducer/moduleReducer/goodsDetail";

export default function ImgsSwiper() {
  const [active, setActive] = useState(0);
  const { state } = useGoodsDetailContext();
  const { detail } = state;
  
  const imgs = useMemo(() => {
    return detail.imageList;
  }, [detail]);
  
  return (
    imgs && imgs.length > 0
    && <>
      <div className="h-[35vh] absolute top-0 md:hidden">
        <img src={imgs[active].fileUrlView}
             style={{
               width: document.body.offsetWidth,
               height: document.body.offsetWidth
             }}/>
      </div>
      
      <div className="py-[40px] flex mdmax:hidden">
        <div className="img-wrap flex-1 mr-[3%]" style={{ maxHeight: 550 }}>
          <img src={imgs[active].fileUrlView}
               style={{ width: '100%', height: '100%' }}/>
        </div>
        <div className="w-[20%]">
          {
            imgs.map((img, i) => (
              <div className="mb-[15px] h-[120px]" key={i}>
                <img src={img.fileUrlView} style={{ width: '100%', height: '100%' }}/>
              </div>
            ))
          }
        </div>
      </div>
    </>
  );
}
